module.exports = __webpack_public_path__ + "static/media/Uniform_2_no_bg.6f0fa694.png";